import { SUBMIT_CONC_FORM_ERROR, SUBMIT_CONC_FORM_POST_ERROR,SUBMIT_CONC_FORM_SUCCESS } from "../actions/types";

export default (state = {  
    error: null,
    results:[],
    success:false,
}, action) => {
    switch (action.type) {
    case SUBMIT_CONC_FORM_SUCCESS:
    return {    
      ...state,
      isSwitchSnackbarOn: true,
      isSnackbarError: false,
      loading: false,
      error:false,
      result:action.payload,
      ErrorMessage: "Submit Success",
      success:true
      }; 
      case SUBMIT_CONC_FORM_POST_ERROR:
            return {
                ...state, 
                error: state.error,
                loading:false,
                success: false,
                isSnackbarError: true,
                isSwitchSnackbarOn: true,
                ErrorMessage: "SUBMIT POST ERROR | CONTACT NETWORK ADMINISTRATOR",
            }
            break; 
    case SUBMIT_CONC_FORM_ERROR:
    return {    
      ...state,
      isSwitchSnackbarOn: true,
      isSnackbarError: true,
      loading: false,
      ErrorMessage: action.payload,
      error:true,
      success:false
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/submitConcessionFormReducer.js